export const reportingPersonFormRules = {
  reportingPerson: [{ required: true, message: 'Reporting person is required!' }],
};
